import ActionTypes from "../../enums/ActionTypes"

export const fetchLanguages = () => ({
  type: ActionTypes.USER_LANGUAGES_REQUEST,
})
